import { setRemoteDefinitions } from "./mf/nx-mf-compat";
import { setManifest } from "@wi-mfes/config";
import { setManifestStore } from "@wi-mfes/remote-loader";
import { createRouteRemoteLoaderState, getRuntimeRemoteUrls, joinUrl, resolveMfManifest, } from "./mf-manifest.utils";
const getBaseUrl = () => {
    return document.body.getAttribute("data-assets") || "";
};
function isLocalHost() {
    return window.location.hostname === "localhost";
}
function getAssetsUrl() {
    let url = "assets/module-federation.manifest.json";
    if (!isLocalHost()) {
        const baseUrl = getBaseUrl();
        url = "apps/admin/assets/module-federation.manifest.json";
        return joinUrl(baseUrl, url);
    }
    return url;
}
fetch(getAssetsUrl())
    .then((res) => res.json())
    .then(async (manifest) => {
    console.log("Fetched manifest: ", manifest);
    const { manifest: resolvedManifest, remoteUrls } = resolveMfManifest(manifest, getBaseUrl(), isLocalHost());
    // Runtime remotes are registered now; route remotes are registered on demand.
    setRemoteDefinitions(getRuntimeRemoteUrls({ manifest: resolvedManifest, remoteUrls }));
    // Set manifest for WIMfConfigService
    setManifest(resolvedManifest);
    const loaderState = createRouteRemoteLoaderState({
        manifest: resolvedManifest,
        remoteUrls,
    });
    setManifestStore(loaderState.manifest, loaderState.remoteUrls);
})
    .then(() => {
    import("./bootstrap").catch((err) => console.error(err));
})
    .catch((err) => {
    console.error("[Host] Failed to load manifest:", err);
    // Fallback: try to bootstrap anyway
    import("./bootstrap").catch((err) => console.error(err));
});
//# sourceMappingURL=main.js.map